/** @format */

import React, { useState } from "react";
import camera from "../../Assets/icons/camera.svg";
import { FiArrowDownCircle } from "react-icons/fi";
import { imgUrl } from "../../services/api";

const UploadPhoto = ({
  file,
  handleUpload,
  name,
  value,
  isEdit = false,
  image,
}) => {
  return (
    <label for={name}>
      <div className='Attachments'>
        <div className='view-img'>
          {file === "" && !isEdit ? (
            <div className='target-photo'>
              {!image ? <h3>
                لا يوجد صوره مضافه
                <h4>اضف صوره</h4>
                <FiArrowDownCircle />
              </h3> :
                <div className='target-photo'>
                  <img src={imgUrl + value} alt="target-photo" />
                </div>
              }

            </div>
          ) : (
            <ImageThumb image={file} isEdit={isEdit} src={image} />
          )}{" "}
        </div>
        <div class='custom__file__input'>
          <div className='img' for={name}>
            <img src={camera} alt='upload-pic' />
          </div>
          <input
            className=' input__photo'
            type='file'
            id={name}
            name='file'
            onChange={handleUpload}
          />
        </div>
      </div>
    </label>
  );
};

export default UploadPhoto;

const ImageThumb = ({ image, isEdit, src }) => {
  return (
    <img
      src={!isEdit ? URL.createObjectURL(image) : imgUrl + src}
      alt={image.name ?? ""}
    />
  );
};
